import React, { useContext, useEffect, useState } from 'react';
import { useStore } from '../../../common';
import { PageAuth, PageContainer, Page, GlobalAlert, Header } from '../../components';
import { PERMISSIONS } from '../../constants';
import { AuthContext } from '../../../logic';
import { Tabs } from './components/Tabs/Tabs';
import { useParams } from 'react-router-dom';
import { InfoTab } from './components/InfoTab/InfoTab';
import { PlayerHeader } from './components/PlayerHeader/PlayerHeader';
import { Wallet } from './components/Wallet/Wallet';

type RouteParams = {
	id: string;
};

const PlayerDetails = (): JSX.Element => {
	const { id } = useParams<RouteParams>();
	const [state, dispatch] = useStore();
	const { player } = state;
	const { token, user } = useContext(AuthContext);
	const [activeTab, setActiveTab] = useState('info');

	const title = `Player ID: ${id} | 
    External Player ID: ${player?.playerData?.external_player_id || '-'} | 
    Username: ${player?.playerData?.user_name || '-'}`;

	useEffect(() => {
		dispatch('LOADING', true);
		dispatch('PARTNERS_INIT', user);
	}, []);

	useEffect(() => {
		if (id) {
			dispatch('PLAYER_INIT', {
				token,
				id,
			});
		}
	}, [id]);

	const tabMap: any = {
		info: <InfoTab />,
		wallet: <Wallet />,
	};

	return (
		<>
			<Header dataId='header' />
			<PageAuth permission={PERMISSIONS.canViewOwnDetails}>
				<PageContainer>
					<Page>
						<div className='position-relative w-100'>
							<PlayerHeader title={title} />
							<Tabs onSelect={setActiveTab} activeTab={activeTab} />
						</div>
						{tabMap[activeTab]}
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

export { PlayerDetails };
